




















import { Component, Prop, Vue } from "vue-property-decorator";
import { MiraSegment } from "@/utils/MiraDataQualityView";

/**
 * The legend of a part-to-whole figure: every part with its colour, its share and its count (the share
 * first, Hans #2610112 X2), the empty parts included, so a value never lives only in a sliver of a bar or a ring. Shared by the stacked
 * bar and the ring beside a legend.
 */
@Component
export default class MiraPartsLegendComponent extends Vue {
  @Prop({ required: true })
  segments!: MiraSegment[];
}
